import { createAsyncThunk } from "@reduxjs/toolkit"
import apiCall from "../../backend/http"

const getUserFromState = (getState) => {
  const state = getState()
  return state.app?.userMngmt?.user
}

const createFleet = createAsyncThunk(
  "auth/createFleet",
  async (postData, { rejectWithValue }) => {
    console.log("Sending to API:", postData)
    try {
      const { data } = await apiCall.post("/api/fleet/vehicles/", postData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Network error" }
      )
    }
  }
)

export const createModel = createAsyncThunk(
  "auth/createModel",
  async (postData, { rejectWithValue }) => {
    try {
      const { data } = await apiCall.post("/api/fleet/models/", postData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })

      return data
    } catch (error) {
      if (error.response?.status === 401) {
        console.log("Authentication error - token may have expired")
      }
      return rejectWithValue(
        error.response?.data?.message || "Server error occurred"
      )
    }
  }
)

export const createMake = createAsyncThunk(
  "auth/createMake",
  async (postData, { rejectWithValue }) => {
    try {
      const { data } = await apiCall.post("/api/fleet/makes/", postData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      return data
    } catch (error) {
      if (error.response) {
        if (error.response.status === 500) {
          return rejectWithValue("Server error: Please try again later")
        }
        return rejectWithValue(
          error.response.data?.message || "Server error occurred"
        )
      } else if (error.request) {
        return rejectWithValue("No response from server")
      } else {
        return rejectWithValue("Failed to send request")
      }
    }
  }
)

export const fetchAllMakes = createAsyncThunk(
  "/auth/fetchAllMakes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall.get("/api/fleet/makes/")
      return response.data
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message || "Failed to Retrieve Makes"
      })
    }
  }
)

export const fetchAllModels = createAsyncThunk(
  "/auth/fetchAllModels",
  async (_, { rejectWithValue, getState }) => {
    try {
      const user = getUserFromState(getState)
      const response = await apiCall.get("/api/fleet/models/", {
        params: {
          user_type: user?.type,
          user_id: user?.id
        }
      })
      return response.data
    } catch (error) {
      console.error("Error fetching models:", error)
      return rejectWithValue({
        message: error.message?.data?.message || "Failed to retrieve Models"
      })
    }
  }
)

export const fetchVehicles = createAsyncThunk(
  "fleet/fetchVehicles",
  async (_, { rejectWithValue, getState }) => {
    try {
      const user = getUserFromState(getState)
      const { data } = await apiCall.get("/api/fleet/vehicles/", {
        params: {
          user_type: user?.type,
          user_id: user?.id
        }
      })
      return data
    } catch (error) {
      console.error("Fetch error:", error)
      return rejectWithValue(
        error.response ? error.response.data : { message: "Network error" }
      )
    }
  }
)

export const deleteMake = createAsyncThunk(
  "fleet/deleteMake",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCall.delete(`/api/fleet/makes/${id}/`)
      return id
    } catch (error) {
      if (error.response?.data?.includes("<!doctype html>")) {
        return rejectWithValue({
          message: "Server encountered an error. Please try again later."
        })
      }
      return rejectWithValue(
        error.response?.data || {
          message: error.message || "Network Error"
        }
      )
    }
  }
)

export const deleteModel = createAsyncThunk(
  "fleet/deleteModel",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCall.delete(`api/fleet/models/${id}/`)
      return id
    } catch (error) {
      if (error.response?.data?.includes("<!doctype html>")) {
        return rejectWithValue({
          message: "Server encountered an error. Please try again later."
        })
      }
      return rejectWithValue(
        error.response?.data || {
          message: error.message || "Network Error"
        }
      )
    }
  }
)

export const deleteVehicle = createAsyncThunk(
  "fleet/deleteVehicle",
  async (id, { rejectWithValue }) => {
    try {
      await apiCall.delete(`/api/fleet/vehicles/${id}/`)
      return id
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : { message: "Network error" }
      )
    }
  }
)

export const updateVehicle = createAsyncThunk(
  "fleet/updateVehicle",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await apiCall.put(`/api/fleet/vehicles/${id}/`, data)
      return response.data
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : { message: "Network error" }
      )
    }
  }
)

export { createFleet }
